import { ref } from 'vue';

const justLoggedIn = ref(false);

export function useAuthState() {
  return { justLoggedIn };
}
